import React, { useState } from 'react'
import './BckPassNew'
import Header from '../Header/Header'
import { Button, Grid } from '@mui/material'


import bk1 from '../../img/dster-webp/bk1.webp'
import bk2 from '../../img/dster-webp/bk2.webp'
import bk3 from '../../img/dster-webp/bk3.webp'
import bk4 from '../../img/dster-webp/bk4.webp'

import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useLocation } from 'react-router-dom'
import HeatMap from '../HeatMap/HeatMap'
import { useTheme, useMediaQuery } from '@mui/material';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));




const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 700,
    overflowY: 'auto',
    '@media(max-width:991.98px)': {
        width: '80%'
    },
    bgcolor: 'var(--clr-explore-bg)',
    border: '2px solid #000',
    BoderRadius: '8px',
    // boxShadow: 24,
    p: 2,
};



function BckInner2() {

    const [cardImg, setCardImg] = useState([
        { img: `${bk1}`, sub: '$22 /month' },
        { img: `${bk2}`, sub: 'free' },
        { img: `${bk2}`, sub: 'free' },
        { img: `${bk3}`, sub: '$22 /month' },
        { img: `${bk4}`, sub: '$22 /month' },


    ])

    const [jnImg, setJnImg] = useState(null)

    const [inputChange, setInputChange] = useState('')

    const handleInputChange = (e) => {
        setInputChange(e.target.value.length)
        console.log(setInputChange, '/200');
    }

    const [free, setFree] = useState(false)
    console.log(free, 'free');


    const [open, setOpen] = React.useState(false);

    const handleOpen = (val) => {
        setOpen(true);
        setJnImg(val.img)
        if (val.sub.toLowerCase() === 'free') {
            setFree(true)

        } else {
            setFree(false)
        }
    }
    const handleClose = () => setOpen(false);
    const [pending, setPending] = useState(false)

    const location = useLocation()

    const result = location.state


    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <div className='BckInner2'>
            <Header />
            <Grid container sx={{ justifyContent: 'center', marginTop: "80px", }}>
                <Grid
                    xs={12}
                    sm={12}
                    md={12}
                    lg={11}
                    xl={10}>
                    <Grid container sx={{ justifyContent: 'center' }} >
                        <Grid
                            xs={12}
                            sm={12}
                            md={12}
                            lg={8}
                            xl={7}
                            order={{ xs: 2, sm: 2, md: 2, lg: 0 }}
                        >

                            <div className='bck-inner-mian' >
                                <div className="">
                                    <HeatMap />
                                </div>
                                <div className='dcl-main'>
                                    <div className='display-2 flex-c' >
                                        <div className='display-1 prf-dck'>
                                            <img src={bk1} alt='bk1' />
                                            <div className='dck-relmen'>
                                                {'Real Men Real Style Community'.slice(0, 25) + '...'}
                                                <div className="dckdc">
                                                    Private • 6.5k • Free
                                                </div>


                                            </div>
                                        </div>
                                        <div className="viewn">
                                            <Button>
                                                View
                                            </Button>
                                        </div>
                                    </div>
                                    <div className='dck-jk'>
                                        {' Discover the foundations of timeless style, classic grooming, and how to be a better man. Members get access to professional training & expert advice'.slice(0, 200) + ' more...'}
                                    </div>
                                </div>


                                <div>
                                    <div className='display-2 flex-c'>
                                        <div className='display-1 prf-dck'>
                                            <img src={bk2} alt='bk1' />
                                            <div className='dck-relmen'>
                                                {"ThunderBoar Mastermind"
                                                    .slice(0, 25) + '...'}
                                                <div className="dckdc">
                                                    Private • 133 • Paid
                                                </div>
                                            </div>
                                        </div>
                                        <div className="viewn">
                                            <Button>
                                                View
                                            </Button>
                                        </div>
                                    </div>
                                    <div className='dck-jk'>
                                        Entrepreneurs seeking Friendship, Growth, & Fulfillment.
                                    </div>
                                </div>

                                <div>
                                    <Grid container sx={{ justifyContent: 'flex-start' }} >

                                        {cardImg.map((row, i) => {
                                            return (
                                                <Grid
                                                    xs={12}
                                                    sm={6}
                                                    md={4}
                                                    lg={4}
                                                    xl={4}>
                                                    <div className='display-1 prf-dck-2'>
                                                        <img src={row.img} alt='bk1' />
                                                        <div className='dck-relmen-2'>
                                                            {"ThunderBoar Mastermind"
                                                                .slice(0, 18) + '...'}
                                                            <div className="dckdc-2">
                                                                Private • 133 • Paid
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            )
                                        })}

                                    </Grid>
                                    <div className="pwby-d  display-1">
                                        powered by<span><svg width="96" height="13" viewBox="0 0 96 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.15625 12.031V0.4375H3.56665C5.15746 0.4375 6.32435 0.549373 7.06729 0.773118C7.91516 1.03462 8.56996 1.37024 9.03168 1.77997C9.49339 2.18971 9.85577 2.61342 10.1188 3.05112C10.6533 3.94051 10.9205 4.95086 10.9205 6.08217C10.9205 7.86235 10.2811 9.30481 9.00229 10.4095C8.09565 11.201 7.02741 11.6898 5.79757 11.8758C5.11479 11.9793 4.15848 12.031 2.92864 12.031H0.15625ZM4.33897 1.06049V11.3514C4.42572 11.357 4.50477 11.3598 4.57612 11.3598H4.76501C6.24529 11.3598 7.51011 10.8983 8.55947 9.97534C9.66898 9.00205 10.2237 7.70992 10.2237 6.09896C10.2237 5.08231 9.98099 4.16705 9.49549 3.35318C8.79032 2.16873 7.67521 1.45065 6.15015 1.19893C5.65206 1.11643 5.04833 1.07028 4.33897 1.06049ZM13.0612 12.031V3.27976H16.587V5.85353C16.9634 4.9194 17.3691 4.23208 17.8043 3.79158C18.238 3.35248 18.6738 3.13293 19.1118 3.13293C19.3566 3.13293 19.5518 3.19726 19.6973 3.32591C19.8414 3.45317 19.9135 3.5965 19.9135 3.75592C19.9135 3.91394 19.8918 4.0391 19.8484 4.1314C19.805 4.22509 19.7477 4.3048 19.6763 4.37052C19.5294 4.50617 19.3902 4.57399 19.2587 4.57399C19.0516 4.57399 18.8984 4.55232 18.7991 4.50897C18.6298 4.43205 18.4793 4.3936 18.3478 4.3936C18.2177 4.3936 18.0512 4.49918 17.8483 4.71034C17.6469 4.9201 17.4531 5.21097 17.267 5.58294C16.8137 6.48911 16.587 7.47219 16.587 8.53219V12.031H13.0612ZM28.579 10.0404C28.7931 10.0404 28.9001 10.1383 28.9001 10.334C28.9001 10.4823 28.8043 10.6571 28.6126 10.8584C27.7493 11.7436 26.5664 12.1862 25.0637 12.1862C23.7135 12.1862 22.5767 11.7793 21.6533 10.9654C20.6963 10.1194 20.2178 9.0489 20.2178 7.75397C20.2178 6.43248 20.6494 5.34521 21.5127 4.49218C22.4263 3.58602 23.6401 3.13293 25.1539 3.13293C26.367 3.13293 27.3863 3.50141 28.2117 4.23837C29.1016 5.03127 29.5465 6.07169 29.5465 7.35962C29.5465 7.54561 29.5416 7.74278 29.5318 7.95115H24.1193V11.4646C24.4914 11.5416 24.9098 11.58 25.3743 11.58C26.3579 11.58 27.1967 11.2549 27.8906 10.6046C28.0334 10.4634 28.1348 10.3515 28.195 10.269C28.3209 10.1166 28.4489 10.0404 28.579 10.0404ZM26.3901 7.35333V3.88597C26.0361 3.78249 25.6345 3.73075 25.1854 3.73075C24.7377 3.73075 24.3823 3.76082 24.1193 3.82095V7.35333H26.3901ZM37.1145 12.031V11.4898C36.4149 11.9541 35.6384 12.1862 34.7849 12.1862C33.6544 12.1862 32.7477 11.9023 32.065 11.3346C31.3542 10.7501 30.9988 9.93898 30.9988 8.90136C30.9988 7.98401 31.3514 7.23027 32.0566 6.64014C32.7771 6.04442 33.725 5.74656 34.9003 5.74656C35.688 5.74656 36.4261 5.89689 37.1145 6.19754V3.94471C36.6164 3.80207 36.1777 3.73075 35.7986 3.73075C35.418 3.73075 35.0969 3.74683 34.8353 3.779C34.5722 3.81256 34.3232 3.8622 34.0881 3.92793C33.5802 4.06917 33.1955 4.26005 32.9338 4.50057C32.7799 4.64321 32.64 4.71453 32.5141 4.71453C32.3896 4.71453 32.2944 4.68307 32.2287 4.62014C32.1629 4.55721 32.13 4.48729 32.13 4.41038C32.13 4.33346 32.1433 4.26424 32.1699 4.20271C32.1979 4.13979 32.2504 4.07546 32.3273 4.00973C32.491 3.8671 32.7638 3.72516 33.1458 3.58392C33.9391 3.28326 34.7345 3.13293 35.532 3.13293C37.9581 3.13293 39.5077 3.71187 40.1807 4.86975C40.4759 5.38297 40.6235 6.0577 40.6235 6.89395V12.031H37.1145ZM37.1145 10.785V6.83522C36.4261 6.5024 35.7398 6.33599 35.0556 6.33599C34.9465 6.33599 34.843 6.34438 34.745 6.36116V11.5716C34.7716 11.5772 34.8017 11.58 34.8353 11.58C34.8674 11.58 34.9003 11.58 34.9339 11.58C35.6824 11.58 36.4093 11.315 37.1145 10.785ZM52.6827 5.54099C52.6938 5.67244 52.6994 5.80389 52.6994 5.93534V12.031H49.182V4.08315C49.1218 4.05518 49.0505 4.0412 48.9679 4.0412H48.7056C48.2803 4.0412 47.7829 4.33347 47.2134 4.918C47.0385 5.09839 46.872 5.29837 46.7139 5.51792V12.031H43.1881V3.27976H46.7139V4.59916C47.6374 3.62168 48.6706 3.13293 49.8137 3.13293C51.2884 3.13293 52.1978 3.67901 52.542 4.77117C53.0121 4.22998 53.5305 3.82165 54.0972 3.54616C54.6624 3.27067 55.2319 3.13293 55.8055 3.13293C56.7835 3.13293 57.5076 3.36507 57.9777 3.82934C58.4478 4.29361 58.6828 4.99561 58.6828 5.93534V12.031H55.1654V4.07476C55.1164 4.05239 54.994 4.0412 54.7981 4.0412C54.6009 4.0412 54.419 4.07826 54.2525 4.15237C54.086 4.22649 53.9153 4.32927 53.7404 4.46072C53.357 4.739 53.0045 5.09909 52.6827 5.54099ZM60.7249 10.934C60.7249 10.8514 60.7536 10.7759 60.8109 10.7074C60.8683 10.6389 60.9432 10.6046 61.0355 10.6046C61.1292 10.6046 61.2062 10.6319 61.2664 10.6864C61.2664 10.6864 61.3342 10.7494 61.4699 10.8752C62.0394 11.3731 62.8348 11.622 63.8562 11.622C64.5445 11.622 64.9874 11.48 65.1846 11.1962C65.2392 11.1192 65.2665 11.0409 65.2665 10.9612C65.2665 10.8829 65.2511 10.8067 65.2203 10.7326C65.1909 10.6585 65.1273 10.5683 65.0293 10.462C64.93 10.3557 64.7901 10.2285 64.6096 10.0802L63.8897 9.49918C62.6977 8.57064 61.8806 7.8169 61.4384 7.23796C61.0341 6.70796 60.8319 6.16678 60.8319 5.61441C60.8319 4.9208 61.1516 4.33906 61.791 3.86919C62.4514 3.37835 63.3063 3.13293 64.3557 3.13293C65.0944 3.13293 65.6764 3.21754 66.1018 3.38674C66.5285 3.55595 66.8293 3.71047 67.0042 3.85032C67.1791 3.98876 67.2666 4.11531 67.2666 4.22998C67.2666 4.46492 67.1735 4.58238 66.9874 4.58238C66.9007 4.58238 66.8202 4.55092 66.7461 4.48799C66.6719 4.42506 66.5257 4.31878 66.3074 4.16915C66.0892 4.01952 65.7996 3.90066 65.4386 3.81256C65.0776 3.72586 64.7411 3.68251 64.4291 3.68251C64.1185 3.68251 63.8988 3.73145 63.7701 3.82934C63.6414 3.92723 63.577 4.02442 63.577 4.12091C63.577 4.216 63.5966 4.3055 63.6358 4.3894C63.6736 4.4747 63.7442 4.57469 63.8478 4.68936C64.0884 4.97324 64.4739 5.30885 65.0042 5.69621C65.5344 6.08497 65.9821 6.44017 66.3473 6.7618C66.7139 7.08483 67.0014 7.38269 67.2099 7.65538C67.5863 8.14762 67.7744 8.64476 67.7744 9.14679C67.7744 9.64881 67.6814 10.0788 67.4953 10.4368C67.3106 10.7948 67.0455 11.1025 66.6999 11.3598C65.9738 11.9107 65.0042 12.1862 63.7911 12.1862C62.8173 12.1862 62.0058 12.0009 61.3566 11.6304C60.9355 11.3954 60.7249 11.1633 60.7249 10.934ZM73.1198 12.1862C70.9778 12.1862 69.9067 11.2087 69.9067 9.25376L69.8983 3.87758L68.956 3.91954C68.6608 3.91954 68.5132 3.80766 68.5132 3.58392C68.5132 3.35877 68.6713 3.2462 68.9875 3.2462L69.7745 3.27976H69.8983V2.01071L73.4158 0.4375V3.27976H74.5134L75.292 3.2462C75.6152 3.2462 75.7768 3.36157 75.7768 3.59231C75.7768 3.69579 75.7313 3.7762 75.6404 3.83353C75.5508 3.89087 75.4487 3.91954 75.334 3.91954L74.3161 3.87758H73.4158V11.58C74.0552 11.5688 74.5875 11.3856 75.0129 11.0304C75.2158 10.878 75.3592 10.6815 75.4431 10.441C75.5285 10.2005 75.6054 10.046 75.674 9.97744C75.7425 9.91032 75.823 9.87675 75.9153 9.87675C76.0077 9.87675 76.0867 9.91311 76.1525 9.98583C76.2182 10.0599 76.2511 10.1473 76.2511 10.248C76.2511 10.3501 76.2238 10.4627 76.1693 10.5857C76.1147 10.7074 76.0328 10.8368 75.9237 10.9738C75.6775 11.2801 75.3934 11.5234 75.0716 11.7038C74.4868 12.0254 73.8362 12.1862 73.1198 12.1862ZM85.2525 10.0404C85.4665 10.0404 85.5736 10.1383 85.5736 10.334C85.5736 10.4823 85.4777 10.6571 85.286 10.8584C84.4228 11.7436 83.2398 12.1862 81.7371 12.1862C80.387 12.1862 79.2502 11.7793 78.3267 10.9654C77.3697 10.1194 76.8912 9.0489 76.8912 7.75397C76.8912 6.43248 77.3229 5.34521 78.1861 4.49218C79.0984 3.58602 80.3114 3.13293 81.8253 3.13293C83.0397 3.13293 84.0597 3.50141 84.8852 4.23837C85.775 5.03127 86.22 6.07169 86.22 7.35962C86.22 7.54561 86.2144 7.74278 86.2032 7.95115H80.7927V11.4646C81.1649 11.5416 81.5832 11.58 82.0477 11.58C83.0313 11.58 83.8701 11.2549 84.5641 10.6046C84.7068 10.4634 84.8082 10.3515 84.8684 10.269C84.9943 10.1166 85.1223 10.0404 85.2525 10.0404ZM83.0635 7.35333V3.88597C82.7081 3.78249 82.3066 3.73075 81.8588 3.73075C81.4111 3.73075 81.0557 3.76082 80.7927 3.82095V7.35333H83.0635ZM88.3019 12.031V3.27976H91.8277V5.85353C92.2055 4.9194 92.6112 4.23208 93.045 3.79158C93.4801 3.35248 93.9159 3.13293 94.3524 3.13293C94.5987 3.13293 94.7946 3.19726 94.9401 3.32591C95.0842 3.45317 95.1562 3.5965 95.1562 3.75592C95.1562 3.91394 95.1346 4.0391 95.0912 4.1314C95.0478 4.22509 94.9905 4.3048 94.9191 4.37052C94.7708 4.50617 94.6316 4.57399 94.5015 4.57399C94.293 4.57399 94.1398 4.55232 94.0418 4.50897C93.8725 4.43205 93.7221 4.3936 93.5906 4.3936C93.4591 4.3936 93.2926 4.49918 93.0911 4.71034C92.8883 4.9201 92.6938 5.21097 92.5077 5.58294C92.0544 6.48911 91.8277 7.47219 91.8277 8.53219V12.031H88.3019Z" fill="url(#paint0_linear_4222_4322)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_4222_4322" x1="93.4598" y1="10.993" x2="23.4492" y2="-32.5681" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#175AFF" />
                                                    <stop offset="1" stop-color="#FC5AFF" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </Grid>
                        <Grid
                            xs={12}
                            sm={12}
                            md={8}
                            lg={4}
                            xl={5}
                            order={{ xs: 1, sm: 1, md: 1, lg: 0 }}
                        >


                            <div>
                                <div className='bck-inner-mian'>
                                    <div className='bck-inner-mian-img-prof text-center'>
                                        <img src={result ? result.img : bk1} alt='join-button' />
                                    </div>
                                    <div className='p-rmr'>
                                        Antonio Centeno
                                    </div>
                                    <div className='p-skllink'>
                                        @antonio
                                    </div>
                                    <div className='p-bckprf'>
                                        Discover the foundations of
                                        timeless style, classic grooming,
                                        and how to be a better man.
                                        Members get access to
                                        professional training & expert
                                        advice
                                    </div>
                                    <Stack
                                        direction="row"
                                        // divider={<Divider orientation="vertical" flexItem className='divborder' />}
                                        spacing={2}
                                        className='stck-n-card2'
                                    >
                                        <div className='rmr'>
                                            Joined Nov 1, 2023
                                        </div>

                                        <div className='rmr'>
                                            Active 5m ago
                                        </div>
                                    </Stack>
                                    <Stack
                                        direction="row"
                                        divider={<Divider orientation="vertical" flexItem className='divborder' />}
                                        spacing={isLgUp ? 1 : 2}
                                        className='stck-n-card'
                                    >
                                        <div className='rmr text-center'>
                                            6.5k
                                            <div className='adm'>
                                                Contributions
                                            </div>
                                        </div>
                                        <div className='rmr text-center'>
                                            40
                                            <div className='adm'>
                                                Followers
                                            </div>
                                        </div>
                                        <div className='rmr text-center'>
                                            5k
                                            <div className='adm'>
                                                Following
                                            </div>
                                        </div>
                                    </Stack>
                                    <Stack
                                        direction="row"
                                        spacing={3}
                                        className='stck-n-prf'
                                    >
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.73636 11.9567C2.73636 9.98261 4.34101 8.37797 6.31506 8.37797H10.9327V6.18457H6.31506C3.12887 6.18457 0.542969 8.77047 0.542969 11.9567C0.542969 15.1429 3.12887 17.7288 6.31506 17.7288H10.9327V15.5354H6.31506C4.34101 15.5354 2.73636 13.9307 2.73636 11.9567ZM7.46948 13.1111H16.7048V10.8022H7.46948V13.1111ZM17.8592 6.18457H13.2416V8.37797H17.8592C19.8333 8.37797 21.4379 9.98261 21.4379 11.9567C21.4379 13.9307 19.8333 15.5354 17.8592 15.5354H13.2416V17.7288H17.8592C21.0454 17.7288 23.6313 15.1429 23.6313 11.9567C23.6313 8.77047 21.0454 6.18457 17.8592 6.18457Z" fill="url(#paint0_linear_4222_4293)" />
                                                <defs>
                                                    <linearGradient id="paint0_linear_4222_4293" x1="23.219" y1="16.5563" x2="0.162833" y2="13.008" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>

                                        </div>
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.5097 1.46191H7.01494C4.1169 1.46191 1.76758 3.81124 1.76758 6.70927V17.204C1.76758 20.102 4.1169 22.4513 7.01494 22.4513H17.5097C20.4077 22.4513 22.757 20.102 22.757 17.204V6.70927C22.757 3.81124 20.4077 1.46191 17.5097 1.46191Z" stroke="url(#paint0_linear_4222_4296)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M16.4617 11.2951C16.5912 12.1684 16.4421 13.0605 16.0354 13.8442C15.6287 14.628 14.9853 15.2635 14.1965 15.6604C13.4078 16.0575 12.5141 16.1957 11.6423 16.0554C10.7705 15.915 9.96522 15.5034 9.34087 14.8791C8.71651 14.2548 8.30493 13.4494 8.16465 12.5777C8.02437 11.7059 8.16255 10.8121 8.55952 10.0234C8.95649 9.23475 9.59205 8.59131 10.3758 8.18464C11.1595 7.77797 12.0516 7.62879 12.925 7.7583C13.8159 7.89041 14.6408 8.30556 15.2776 8.94242C15.9144 9.57929 16.3296 10.4041 16.4617 11.2951Z" stroke="url(#paint1_linear_4222_4296)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M18.0371 6.18457H18.0484" stroke="url(#paint2_linear_4222_4296)" stroke-width="2.09894" stroke-linecap="round" stroke-linejoin="round" />
                                                <defs>
                                                    <linearGradient id="paint0_linear_4222_4296" x1="22.3822" y1="20.3196" x2="1.05187" y2="18.6783" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                    <linearGradient id="paint1_linear_4222_4296" x1="16.3572" y1="15.256" x2="7.82504" y2="14.5995" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                    <linearGradient id="paint2_linear_4222_4296" x1="18.0482" y1="7.08301" x2="18.0367" y2="7.083" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>

                                        </div>
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.5907 10.1834L22.9967 0.412109H21.0048L13.7058 8.89642L7.87616 0.412109H1.15234L9.96793 13.2419L1.15234 23.4886H3.14442L10.8523 14.5289L17.0088 23.4886H23.7327L14.5902 10.1834H14.5907ZM11.8623 13.3549L10.9691 12.0774L3.86219 1.91171H6.9219L12.6572 10.1157L13.5504 11.3933L21.0057 22.0572H17.946L11.8623 13.3554V13.3549Z" fill="url(#paint0_linear_4222_4301)" />
                                                <defs>
                                                    <linearGradient id="paint0_linear_4222_4301" x1="23.3294" y1="21.1449" x2="0.376639" y2="19.4167" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>

                                        </div>
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.8915 6.80331C20.7818 6.36501 20.5584 5.96342 20.2438 5.63911C19.9292 5.3148 19.5346 5.07924 19.0999 4.95624C17.5114 4.56836 11.1575 4.56836 11.1575 4.56836C11.1575 4.56836 4.80354 4.56836 3.21506 4.99319C2.7803 5.11618 2.38571 5.35174 2.07112 5.67606C1.75654 6.00036 1.53311 6.40195 1.4234 6.84026C1.13269 8.45234 0.990483 10.0877 0.998575 11.7258C0.988214 13.3761 1.13043 15.024 1.4234 16.6482C1.54435 17.0728 1.77278 17.4592 2.08664 17.7698C2.40048 18.0804 2.78914 18.3048 3.21506 18.4214C4.80354 18.8462 11.1575 18.8462 11.1575 18.8462C11.1575 18.8462 17.5114 18.8462 19.0999 18.4214C19.5346 18.2984 19.9292 18.0629 20.2438 17.7385C20.5584 17.4142 20.7818 17.0126 20.8915 16.5743C21.18 14.9744 21.3222 13.3515 21.3164 11.7258C21.3267 10.0754 21.1845 8.42753 20.8915 6.80331Z" stroke="url(#paint0_linear_4222_4304)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.07812 14.745L14.3885 11.725L9.07812 8.70508V14.745Z" stroke="url(#paint1_linear_4222_4304)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <defs>
                                                    <linearGradient id="paint0_linear_4222_4304" x1="20.9541" y1="17.3961" x2="0.429066" y2="15.1485" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                    <linearGradient id="paint1_linear_4222_4304" x1="14.2936" y1="14.1316" x2="8.88983" y2="13.766" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>

                                        </div>
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.9921 8.28418C17.6622 8.28418 19.2638 8.94759 20.4446 10.1285C21.6256 11.3094 22.289 12.911 22.289 14.581V21.9273H18.0911V14.581C18.0911 14.0244 17.87 13.4905 17.4763 13.0968C17.0826 12.7032 16.5488 12.4821 15.9921 12.4821C15.4355 12.4821 14.9016 12.7032 14.508 13.0968C14.1143 13.4905 13.8932 14.0244 13.8932 14.581V21.9273H9.69531V14.581C9.69531 12.911 10.3587 11.3094 11.5397 10.1285C12.7205 8.94759 14.3221 8.28418 15.9921 8.28418Z" stroke="url(#paint0_linear_4222_4308)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M5.49671 9.33301H1.29883V21.9267H5.49671V9.33301Z" stroke="url(#paint1_linear_4222_4308)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M3.39777 6.18421C4.55699 6.18421 5.49671 5.24449 5.49671 4.08527C5.49671 2.92606 4.55699 1.98633 3.39777 1.98633C2.23856 1.98633 1.29883 2.92606 1.29883 4.08527C1.29883 5.24449 2.23856 6.18421 3.39777 6.18421Z" stroke="url(#paint2_linear_4222_4308)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <defs>
                                                    <linearGradient id="paint0_linear_4222_4308" x1="22.0641" y1="20.5417" x2="9.25473" y2="19.6318" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                    <linearGradient id="paint1_linear_4222_4308" x1="5.42175" y1="20.6476" x2="1.13325" y2="20.5376" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                    <linearGradient id="paint2_linear_4222_4308" x1="5.42175" y1="5.75787" x2="1.15569" y2="5.4296" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>

                                        </div>
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.7434 1.46191H14.595C13.2033 1.46191 11.8686 2.01475 10.8846 2.99883C9.90047 3.9829 9.34763 5.31759 9.34763 6.70927V9.85769H6.19922V14.0556H9.34763V22.4513H13.5455V14.0556H16.6939L17.7434 9.85769H13.5455V6.70927C13.5455 6.43093 13.6561 6.164 13.8529 5.96718C14.0497 5.77037 14.3166 5.6598 14.595 5.6598H17.7434V1.46191Z" stroke="url(#paint0_linear_4222_4313)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <defs>
                                                    <linearGradient id="paint0_linear_4222_4313" x1="17.5373" y1="20.3196" x2="5.75721" y2="19.8211" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#175AFF" />
                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>

                                        </div>
                                    </Stack>
                                </div>
                            </div>

                        </Grid>

                    </Grid>

                </Grid>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        {free ? <>
                            <>
                                {pending ? <>
                                    <div className='answer-banner'>
                                        <img src={jnImg} alt='adf' />
                                        <div className='realmen-h'>
                                            Membership pending
                                        </div>
                                        <div className='realmen-d'>
                                            Real Men Real Style Community admins are reviewing your request. You'll get an email when you're approved.
                                        </div>
                                    </div>

                                </> :
                                    <>

                                        <div className='answer-banner'>
                                            <img src={jnImg} alt='adf' />
                                            <div className='realmen-h'>
                                                Real Men Real Style Community
                                            </div>
                                            <div className='realmen-d'>
                                                Answer questions to join group
                                            </div>
                                        </div>
                                        <div className='ask1'>
                                            Youve been invited to a fancy dinner hosted by a friend. What outfit will you wear that would make you feel like a million bucks? In detail please!
                                        </div>
                                        <div className='numver20 text-right'>
                                            {`${inputChange ? inputChange : 0}/200`}
                                        </div>
                                        <div className='ask-inp'>
                                            <TextField id="outlined-basic" variant="outlined" onChange={handleInputChange} />
                                        </div>
                                        <div className='ask1'>
                                            Why do you even care about style? Help me understand why being part of this group is important to you. (You must answer!)
                                        </div>
                                        <div className='numver20 text-right'>
                                            {`${inputChange ? inputChange : 0}/200`}
                                        </div>
                                        <div className='ask-inp'>
                                            <TextField id="outlined-basic" variant="outlined" />
                                        </div>

                                        <div className='ask1'>
                                            What's your best email address? I promise no spam— just weekly community updates and important reminders.
                                        </div>
                                        <div className='numver20 text-right'>
                                            {`${inputChange ? inputChange : 0}/200`}
                                        </div>
                                        <div className='ask-inp'>
                                            <TextField id="outlined-basic" variant="outlined" />
                                        </div>

                                    </>}
                            </>

                        </> : <>
                            {pending ? <>
                                <div className='answer-banner'>
                                    <img src={jnImg} alt='adf' />
                                    <div className='realmen-h'>
                                        Membership pending
                                    </div>
                                    <div className='realmen-d'>
                                        Real Men Real Style Community admins are reviewing your request. You'll get an email when you're approved.
                                    </div>
                                </div>

                            </> :
                                <>

                                    <div className='answer-banner'>
                                        <img src={jnImg} alt='adf' />
                                        <div className='realmen-h'>
                                            Real Men Real Style Community
                                        </div>
                                        <div className='realmen-d'>
                                            $22 /month membership. Cancel anytime.
                                        </div>
                                    </div>
                                    <div className='ask1'>
                                        Email for membership
                                    </div>

                                    <div className='ask-inp'>
                                        <TextField id="outlined-basic" variant="outlined" placeholder='example@gmail.com' onChange={handleInputChange} />
                                    </div>

                                    <div className='ask1'>
                                        Payment information
                                    </div>

                                    <div className='ask-inp display-1'>
                                        <TextField id="outlined-basic" placeholder='Card number' variant="outlined" />
                                        <TextField id="outlined-basic" placeholder='MM/YY' className='mmcv' variant="outlined" />    <TextField id="outlined-basic" placeholder='CVV' className='mmcv' variant="outlined" />
                                    </div>
                                    <div className='answer-banner'>

                                        <div className='ask1 text-center'>
                                            By joining, you accept ANIME SHREDS and Skool's terms. You allow them to charge your card $22 now and $22 every month after that You can cancel anytime-
                                        </div>

                                    </div>


                                </>}
                        </>}

                        <div className='joinask'>
                            <Button onClick={() => setPending(!pending)}>
                                JOIN GROUP
                            </Button>
                        </div>

                    </Box>
                </Modal>
            </Grid>
        </div >
    )
}

export default BckInner2
